import { RootState } from 'baas-ui/types';

export const getAppId = (state: RootState) => state.app.app.id;
export const getGroupId = (state: RootState) => state.app.app.groupId;
